import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import React from "react";
import { GoogleMap, useJsApiLoader, Marker } from "@react-google-maps/api";

// import { Container } from './styles';
interface IProps {
  onClose: () => void;
  latitude: number;
  longitude: number;
}

const MapsModal: React.FC<IProps> = ({ onClose, latitude, longitude }) => {
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyCjWRwBGGN0k2BqC7rPzA14U6M2WQt55CA",
  });

  return (
    <Modal isOpen onClose={onClose} size="5xl">
      <ModalOverlay />
      <ModalContent bgColor="gray">
        <ModalHeader color="white">Localização</ModalHeader>
        <ModalCloseButton color="white" onClick={onClose} />
        <ModalBody>
          {isLoaded && (
            <GoogleMap
              mapContainerStyle={{
                width: "100%",
                height: "600px",
              }}
              center={{
                lat: latitude,
                lng: longitude,
              }}
              zoom={15}
            >
              <Marker
                position={{
                  lat: latitude,
                  lng: longitude,
                }}
              />
            </GoogleMap>
          )}
        </ModalBody>

        <ModalFooter></ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default MapsModal;
